export const LANES = [1, 2, 3, 4, 5, 6] as const;
export type Lane = (typeof LANES)[number];

export const FREE_VEHICLE_PRESETS = [
  "sedan",
  "hatchback",
  "compact-suv",
  "minivan",
] as const;
export type FreeVehiclePreset = (typeof FREE_VEHICLE_PRESETS)[number];

export const PAID_VEHICLE_PRESETS = [
  "retro-coupe",
  "sports-coupe",
  "microcar",
  "utility-wagon",
  "roadster",
  "boxy-electric",
] as const;

export const VEHICLE_PRESETS = [
  ...FREE_VEHICLE_PRESETS,
  ...PAID_VEHICLE_PRESETS,
] as const;
export type VehiclePreset = (typeof VEHICLE_PRESETS)[number];

export const HORN_IDS = [
  "classic",
  "courtesy",
  "foghorn",
  "scooter",
  "melody",
] as const;
export type HornId = (typeof HORN_IDS)[number];

export const REACTIONS = ["wave", "sigh", "coffee", "turtle"] as const;
export type Reaction = (typeof REACTIONS)[number];

export const TRAFFIC_STATES = [
  "CLEAR",
  "MOVING",
  "SLOW",
  "JAMMED",
  "GRIDLOCK",
  "PARKING LOT",
] as const;
export type TrafficState = (typeof TRAFFIC_STATES)[number];

export type PerformanceTier = "high" | "standard" | "reduced";
export type RealtimeMode =
  "full" | "reduced" | "aggregate" | "offline" | "mock";
export type ConnectionState = "connected" | "offline" | "connecting";

import type { CoarseLocation } from "../features/location/coarseLocation";

export type { CoarseLocation };

export type DriverProfile = {
  publicDriverId: string;
  plate: string;
  vehiclePreset: VehiclePreset;
  colorId: string;
  hornId: HornId;
  badge: "garage" | "founding" | null;
  garageOwned: boolean;
  odometerMiles: number;
};

export type RemoteDriver = {
  sessionId: string;
  publicDriverId: string;
  lane: Lane;
  joinedAt: string;
  vehiclePreset: VehiclePreset;
  colorId: string;
  plate: string;
  badge: "garage" | "founding" | null;
  sessionElapsedSeconds: number;
  sessionDistanceMiles: number;
  location: CoarseLocation | null;
  presenceReceivedAt?: number;
  departing?: boolean;
};

export type TrafficSnapshot = {
  activeDriverCount: number;
  targetSpeedMph: number;
  state: TrafficState;
  snapshotAt: string;
};

export type TrafficEvent =
  | { type: "honk"; sessionId: string; at: number }
  | { type: "flash"; sessionId: string; at: number }
  | { type: "reaction"; sessionId: string; reaction: Reaction; at: number }
  | { type: "lane"; sessionId: string; lane: Lane; at: number }
  | { type: "exit"; sessionId: string; at: number };

export type TripReport = {
  profile: DriverProfile;
  elapsedSeconds: number;
  distanceMiles: number;
  peakDriverCount: number;
  worstState: TrafficState;
  enduredDelaySeconds: number;
  addedDelaySeconds: number;
  finishedAt: string;
  location?: CoarseLocation | null;
};
